// extracted by mini-css-extract-plugin
export default {"container":"AdminConfigTractorHistory_container__2jKXA"};